import script from "./criteria.vue?vue&type=script&lang=js&setup=true"
export * from "./criteria.vue?vue&type=script&lang=js&setup=true"

import "./criteria.vue?vue&type=style&index=0&id=609a6fb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-609a6fb6"]])

export default __exports__